import { Dialog } from "@asurion-core/aui-react-overlays";
import { Action, ActionGroup, Text } from "@asurion-core/mx-asurion-ui-react";
import { ModalDialog } from "@ubif/components";
import { getCheckoutRefundUrl, getRepairWorkorderUrl } from "@ubif/util-store";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface SalesOrderWorkorderScanModalProps {
  salesOrderId: string;
  workorderId: string;
  onClose: () => void;
}

export const SalesOrderWorkorderScanModal = ({
  salesOrderId,
  workorderId,
  onClose
}: SalesOrderWorkorderScanModalProps) => {
  const { t } = useTranslation("root-config");

  const numericWorkorderId = workorderId.replace(/^WO/i, "");

  return (
    <ModalStyle
      isOpen={true}
      onCloseModal={onClose}
      aria-label={t("SalesOrderWorkorderScanModal.title")}
      title={t("SalesOrderWorkorderScanModal.title")}
    >
      <Dialog.Content>
        <Text size={2}>
          {t("SalesOrderWorkorderScanModal.description", {
            salesOrderId,
            workorderId: numericWorkorderId
          })}
        </Text>
      </Dialog.Content>
      <ActionGroup>
        <Action
          variant="outline"
          href={getCheckoutRefundUrl(salesOrderId)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClose}
        >
          {t("SalesOrderWorkorderScanModal.startRefund")}
        </Action>
        <Action
          href={getRepairWorkorderUrl(numericWorkorderId)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClose}
        >
          {t("SalesOrderWorkorderScanModal.navigateToWorkorder")}
        </Action>
      </ActionGroup>
    </ModalStyle>
  );
};

const ModalStyle = styled(ModalDialog)`
  width: 29.5rem;
  min-height: auto;
`;
